import { Button, Icon } from '@sbv-clients/ui-shared';

import { SideDrawerType, UseContextFnTypeForPageSideDrawer } from './util';

export function FindEmployeesButton({
  useContextFn,
}: {
  useContextFn: () => UseContextFnTypeForPageSideDrawer;
}) {
  const { sideDrawerState, setSideDrawerState } = useContextFn();
  const open = sideDrawerState === SideDrawerType.FIND_EMPLOYEES;
  const handleOnClick = () => {
    setSideDrawerState(open ? undefined : SideDrawerType.FIND_EMPLOYEES);
  };

  return (
    <Button
      variant={open ? 'contained' : 'text'}
      endIcon={<Icon name={'ContactPage'} />}
      onClick={handleOnClick}
      size={'small'}
    >
      Employees
    </Button>
  );
}
